import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/layouts/Navbar";
import Footer from "./components/layouts/Footer";
import CursorGlow from "./components/layouts/CursorGlow";
import User from "./components/users/User";
import Alert from "./components/layouts/Alert";
import About from "./components/pages/About";
import Home from "./components/pages/Home";
import NotFound from "./components/pages/NotFound";
import ErrorBoundary from "./components/layouts/ErrorBoundary";
import GithubState from "./context/github/GithubState";
import AlertState from "./context/alert/AlertState";
import "./App.css";

const App = () => {
  return (
    <ErrorBoundary>
      <GithubState>
        <AlertState>
          <Router>
            <CursorGlow />
            <div className="App">
              <Navbar />
              <div className="container">
                <Alert />
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/user/:login" element={<User />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </div>
              <Footer />
            </div>
          </Router>
        </AlertState>
      </GithubState>
    </ErrorBoundary>
  );
};

export default App;
